// @ts-strict-ignore
import { Updatable } from './updatable';
import { NonErrorRunwayResponseTypes } from '@/types';

export const UPDATED_START = 'UPDATED_START';
export const UPDATED_STOP = 'UPDATED_STOP';
export const WILL_UPDATE_START = 'WILL_UPDATE_START';
export const WILL_UPDATE_STOP = 'WILL_UPDATE_STOP';

export interface UpdatedActionPayloadType {
    updatedType: Updatable | string;
    id?: number | string; // used to link actions that can be performed on multiple instances to a specific instance
    responseType?: NonErrorRunwayResponseTypes;
}

interface UpdatedStartAction {
    type: typeof UPDATED_START;
    payload: UpdatedActionPayloadType;
}

interface UpdatedStopAction {
    type: typeof UPDATED_STOP;
    payload: UpdatedActionPayloadType;
}

interface WillUpdateStartAction {
    type: typeof WILL_UPDATE_START;
    payload: UpdatedActionPayloadType;
}

interface WillUpdateStopAction {
    type: typeof WILL_UPDATE_STOP;
    payload: UpdatedActionPayloadType;
}

export type UpdatedActionType = UpdatedStopAction | UpdatedStartAction;
export type WillUpdateActionType = WillUpdateStartAction | WillUpdateStopAction;

// Action creators

export const willUpdateStartAction: (updatedType: Updatable | string, id?: number | string) => WillUpdateStartAction = (
    updatedType,
    id = null,
) => {
    return {
        type: WILL_UPDATE_START,
        payload: {
            updatedType,
            id,
        },
    };
};

export const willUpdateStopAction: (updatedType: Updatable | string, id?: number | string) => WillUpdateStopAction = (
    updatedType,
    id = null,
) => {
    return {
        type: WILL_UPDATE_STOP,
        payload: {
            updatedType,
            id,
        },
    };
};

export const updatedStartAction: (
    updatedType: Updatable | string,
    id?: number | string,
    responseType?: NonErrorRunwayResponseTypes,
) => UpdatedActionType = (updatedType, id = null, responseType = null) => {
    return {
        type: UPDATED_START,
        payload: {
            updatedType,
            id,
            responseType,
        },
    };
};

export const updatedStopAction: (
    updatedType: Updatable | string,
    id?: number | string,
    responseType?: NonErrorRunwayResponseTypes,
) => UpdatedActionType = (updatedType, id = null, responseType = null) => {
    return {
        type: UPDATED_STOP,
        payload: {
            updatedType,
            id,
            responseType,
        },
    };
};
